/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingEquipmentItemDto } from './buildingEquipmentItemDto';
import { MaintenanceTimerPermissions } from './maintenanceTimerPermissions';
import { BuildingItemDto } from './buildingItemDto';
import { TenantItemDto } from './tenantItemDto';
import { EquipmentItemDto } from './equipmentItemDto';


export interface MaintenanceTimerItemDto { 
    id: string;
    created: string;
    type: MaintenanceTimerItemDto.TypeEnum;
    building: BuildingItemDto;
    buildingEquipment: BuildingEquipmentItemDto;
    equipment: EquipmentItemDto;
    startDate: string;
    durationDays: number;
    nextDate: string;
    reminderDurationDays: number;
    creatorTenant: TenantItemDto;
    permissions: MaintenanceTimerPermissions;
    earlyToleranceDays: number;
    lateToleranceDays: number;
    imagesMandatory: boolean;
}
export namespace MaintenanceTimerItemDto {
    export type TypeEnum = 'Maintenance' | 'Inspection' | 'SelfInspection' | 'Warranty';
    export const TypeEnum = {
        Maintenance: 'Maintenance' as TypeEnum,
        Inspection: 'Inspection' as TypeEnum,
        SelfInspection: 'SelfInspection' as TypeEnum,
        Warranty: 'Warranty' as TypeEnum
    };
}


